import React from 'react'
import Swal from 'sweetalert2';
import { utcToLocalTime } from '../../../../../Studio-Services/Studio_Services';

export default function MemberActivePurchasedPasses({
    logo,
    familyRecurringItems,
    familyTimeFrameItems,
    familyPunchItems,
    familyRecurringActivePunch,
    studioData,
    changeStatus,
    changeExPassInfo,
    changePassInfo,
    checkCardExpire,
    setPunchConfirmShow
}) {

    const recurringItems = Array.isArray(familyRecurringItems) ? familyRecurringItems : [];
    const timeFrameItems = Array.isArray(familyTimeFrameItems) ? familyTimeFrameItems : [];
    const punchItems = Array.isArray(familyPunchItems) ? familyPunchItems : [];
    const recurringActivePunch = Array.isArray(familyRecurringActivePunch) ? familyRecurringActivePunch : [];


    return (
        <>
            <h4 className="title text-capitalize mt-5">Active Purchased Passes </h4>
            {/* *** Family Recurring Active Passes  */}
            <h4 className="group_card mt-3">Recurring Membership</h4>
            {recurringItems.length > 0 &&
                <div className="row pt-4" >
                    {recurringItems.map((lists) => (
                        <div className="col-md-6 col-xl-4">
                            <div className="prelist-pass p-3 blueback-passes mb-3">
                                <div className="mx-0 row align-items-center">
                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.full_price} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-8">
                                        {/* <p>Remaining Days : {lists && lists.remaining_count ? lists.remaining_count : 'XX'} of {lists.total_count}</p> */}
                                        <p>Start Date :  {utcToLocalTime(lists.start_date_utc)}</p>
                                        {lists.pass_cancellation_date == '' && lists.pass_pause_start_less_then_thirty == '' &&
                                            <p style={{ textTransform: 'capitalize' }}>Status:  {lists.card_status}</p>}
                                        {lists.pass_cancellation_date != '' && lists.pass_pause_start_less_then_thirty == '' &&
                                            <p>Status: Cancelled</p>}
                                        {lists.pass_pause_start_less_then_thirty != '' &&
                                            <p >Status: Paused</p>}
                                        {lists.pass_pause_start_less_then_thirty != '' && lists.is_recurring_stop != 0 &&
                                            <p >Paused:  {utcToLocalTime(lists.pass_pause_start_less_then_thirty)}</p>}
                                        {lists.pass_pause_end_less_then_thirty != '' && lists.is_recurring_stop != 0 &&
                                            <p>Restart Date:{utcToLocalTime(lists.pass_pause_end_less_then_thirty)}</p>}
                                    </div>
                                    <div className="col-4">
                                        {lists.passes_status == 1 && lists.pass_cancellation_date == '' && lists.card_status == 'active' &&
                                            <button className="btn btn-brandgreengrad text-center"
                                                onClick={() => changeStatus(1, lists.booking_pass_id, lists.pass_id, lists)}
                                            // onClick={handleShow}
                                            >Active
                                            </button>}
                                        {lists.is_recurring_stop == 1 && lists.pass_cancellation_date == '' && lists.card_status == 'paused' &&
                                            <button className="btn btn-brandyellows text-right" style={{ background: '#fafa00' }} onClick={() => changeStatus(0, lists.booking_pass_id, lists.pass_id, lists)}
                                            >Paused
                                            </button>
                                        }
                                        {lists.is_recurring_stop == 1 && lists.pass_type_subcat != 36 &&
                                            <button className="btn btn-brandyellows text-right" style={{ background: '#fafa00' }} onClick={() => changeStatus(0, lists.booking_pass_id, lists.pass_id, lists)}
                                                disabled>Paused
                                            </button>}

                                        {/* changeStatus(0, lists.booking_pass_id, lists.pass_id, lists) */}
                                        {lists.pass_cancellation_date != '' && lists.pass_pause_start_less_then_thirty == '' &&
                                            <button className="btn btn-brandyellowcancel text-right" onClick={() => {
                                                Swal.fire({
                                                    html: `
                                                        <img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                                                        <h4 class="title text-capitalize text-center mt-4 textWhite">Notice</h4>
                                                        <p class="text-center my-4 textcolor">
                                                            <small class="textWhite">Passes that are cancelled are not allowed to be reactivated.
                                                            You can let the client purchase a new pass when it expires.   Or purchase it for them using a card on file. 
                                                            </small>
                                                        </p>
                                                        `,
                                                    showClass: {
                                                        popup: 'custom-dialog-container',
                                                    },
                                                    customClass: {
                                                        confirmButton: 'custom-button custom-button-size modalbtn',
                                                    },
                                                    confirmButtonText: 'OK',
                                                })
                                            }}
                                                style={{ marginLeft: "-5px" }}>Cancelling
                                            </button>}
                                    </div>
                                    <div col-md-12>
                                        {/* {lists.pass_cancellation_date != '' &&
                                                                                                            <p>Cancel Date:  {moment(lists.pass_cancellation_date).format(' MMMM DD, YYYY')}</p>} */}
                                        {lists.pass_cancellation_date == '' && lists.passes_status == 1 &&
                                            <p>Expiry Date: {utcToLocalTime(lists.pass_expired_date)}
                                                <button type="button" className="fa fa-edit" data-toggle="modal" data-target="#passInfoExpireDateModel"
                                                    onClick={() => changeExPassInfo(lists)}
                                                ></button></p>}
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                    </div>
                                    <div className="col-4">
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {recurringItems.length == 0 &&
                <div> <p className="text-center">No Records Found</p></div>
            }

            {/* *** Family Time Frame Active Passes  */}

            <h4 className="group_card mt-3">Time Frame</h4>
            {timeFrameItems.length > 0 &&
                <div className="row pt-4">
                    {timeFrameItems.map((lists) => (
                        <div className="col-md-6 col-lg-4" >
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-8">
                                        <p className="font-12">Expiration Date :
                                            {utcToLocalTime(lists.end_date_utc)} <button type="button"
                                                className="fa fa-edit" data-toggle="modal"
                                                data-target="#passInfoModel"
                                                onClick={() => changePassInfo(lists)}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {timeFrameItems.length == 0 &&
                <div><p className="text-center">No Records Found</p> </div>
            }

            {/* *** Family Punch Active Passes  */}
            <h4 className="group_card mt-3">Punch Card</h4>
            {punchItems.length > 0 &&
                <div className="row pt-4">
                    {punchItems.map((lists) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-9">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="passnew_logo">
                                            <img src={studioData && studioData.business_img} className="img-fluid" />
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.remaining_count} of {lists.total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists) }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date : {utcToLocalTime(lists.end_date_utc)}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoDateModel" className="fa fa-edit"
                                                onClick={() => changePassInfo(lists, 2)}
                                            ></button>

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {punchItems.length == 0 &&
                <div > <p className="text-center">No Records Found</p> </div>
            }


            {/* *** Family Recurring Punch Active Passes  */}
            <h4 className="group_card mt-3">Recurring Punch Card</h4>
            {recurringActivePunch.length > 0 &&
                <div className="row pt-4">
                    {recurringActivePunch.map((lists) => (
                        <div className="col-md-6 col-lg-4">
                            <div className="prelist-pass p-3 blueback-passes">
                                <div className="mx-0 row align-items-center">

                                    <div className="col-md-8">
                                        <div className="passdetail_new flex-fill">
                                            <p className="mb-0 text-capitalize">{lists.pass_name}</p>
                                            <h6 className="mb-2"> $ {lists.amount} <small>Plus Tax</small></h6>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="row">
                                            <div className="passnew_logo">
                                                <img src={studioData && studioData.business_img} className="img-fluid" />
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            {lists?.is_recurring_stop == '0' ?
                                                <button className="btn btn-brandgreengrad text-center" style={{ height: '35px' }}
                                                    onClick={() => {
                                                        setPunchConfirmShow({ status: true, data: lists, chield: true });
                                                    }}
                                                >Active
                                                </button>
                                                :
                                                <button className="btn btn-brandyellowcancel text-center"
                                                    style={{ marginLeft: "-5px" }}>Cancelling
                                                </button>
                                            }
                                        </div>
                                    </div>

                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p>Remaining Classes : {lists.remaining_count} of {lists.total_count}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoModel" className="fa fa-edit"
                                                onClick={() => { checkCardExpire(lists?.end_date_utc) && changePassInfo(lists) }}
                                            ></button>
                                        </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Start Date :
                                            {utcToLocalTime(lists.start_date_utc)} </p>
                                    </div>
                                </div>
                                <div className="row mt-1 align-items-end">
                                    <div className="col-md-12">
                                        <p className="font-12">Expiration Date : {utcToLocalTime(lists.end_date_utc)}
                                            <button type="button" data-toggle="modal"
                                                data-target="#passInfoDateModel" className="fa fa-edit"
                                                onClick={() => changePassInfo(lists, 2)}
                                            ></button>

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
            {recurringActivePunch.length == 0 &&
                <div> <p className="text-center">No Records Found</p> </div>
            }

        </>
    )
}
